import { unSlash } from "./unSlash"
import { getBaseURL } from "./getBaseURL";

export function replaceURL(url) {
	return unSlash( url.replace(getBaseURL(), '').replace(global.config.devURL, '') )
}